var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeimanMarcusCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 36 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .375h8.658v13.617H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.342.102h9.654V13H.342z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#D3D3D3",
    fill: "#FFF",
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 23,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.225 11.993C7.177 8.47 7.232 4 8.632.683c.079-.148-.02-.308-.295-.308-.197 0-.296.061-.354.21C6.759 3.88 6.62 7.25 6.606 10.613c-.442-1.05-.912-2.307-1.518-4.04-.571-1.627-.886-2.897-1.359-5.472-.04-.222-.236-.345-.551-.345-.335 0-.532.148-.532.394 0 .495.08 1.25.204 2.004-.068 2.812-.425 6.688-1.503 9.186-.08.16-.178.259-.257.259-.157 0-.295-.222-.53-.888-.04-.086-.119-.148-.296-.148-.178 0-.296.099-.257.26.572 1.737.69 2.168 1.202 2.168.354 0 .57-.172.728-.567.928-2.301 1.224-5.409 1.394-8.092.708 2.698 1.778 5.468 2.8 7.476.138.271.394.382.729.382.532 0 .787-.246.61-.702a27.261 27.261 0 01-.245-.496",
    fill: "#000",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.662 9.787c-.191.156-.337.517-.51.517-.168 0-.336-.4-.441-1.054-.483-2.727-.525-5.986-.273-8.082.02-.182-.042-.267-.232-.267-.146 0-.252.049-.314.206C6.958 3.42 5.97 6.063 5.396 7.78c-.092-.691-.332-1.923-.655-3.267-.315-1.296-.693-3.053-.777-4.06-.021-.241-.21-.35-.546-.35-.378 0-.567.145-.525.387.077.45.15.904.217 1.346-.348 3.172-1.13 8.14-2.728 10.828-.1.136-.012.303.28.332.209.021.32-.029.398-.167 1.443-2.702 2.012-5.549 2.384-8.417l.017-.095c.043.333.587 5.32.944 7.175.021.109.105.194.294.194.231 0 .315-.11.336-.194.599-2.437 1.197-4.5 1.81-6.274.098 2.349.31 4.612.522 5.523.21.908.483 1.272.903 1.272.493 0 1.596-1.23 1.7-1.734.103-.502-.118-.647-.308-.49",
    fill: "#000",
    mask: "url(#d)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeimanMarcusCard);
export default __webpack_public_path__ + "static/media/NeimanMarcusCard.757f032a5a8189cbb39e716804fecbec.svg";
export { ForwardRef as ReactComponent };